import type {
  RoutingPlanResource,
  RoutingResource,
} from '@/features/legends/api/resources/routing'
import type { LegacyIdFixer } from '@/features/legends/editor/legacy-ids'
import {
  mapRuleResourcesToRules,
  mapRulesToResources,
} from '@/features/legends/filters/rule-mappers'
import type { Routing, RoutingPlan } from './routing'

/**
 * Maps the routing, fixing references to legacy question IDs.
 *
 * @param resource
 * @param ids
 */
export function mapRoutingResourceToRouting(
  resource: RoutingResource,
  ids: LegacyIdFixer,
): Routing {
  return {
    requirements: resource.requirements
      ? mapRuleResourcesToRules(resource.requirements, ids)
      : undefined,
    plans: resource.plans?.map((plan): RoutingPlan => ({
      id: plan.id,
      label: plan.label,
      description: plan.description,
      duration: plan.duration,
      requirements: plan.requirements
        ? mapRuleResourcesToRules(plan.requirements, ids)
        : undefined,
    })),
  }
}

/**
 * Maps the routing to the API's.
 *
 * @param routing
 */
export function mapRoutingToResource(routing: Routing): RoutingResource {
  return {
    requirements:
      routing.requirements && mapRulesToResources(routing.requirements),
    plans: routing.plans?.map((plan): RoutingPlanResource => ({
      id: plan.id,
      label: plan.label,
      description: plan.description,
      requirements: plan.requirements && mapRulesToResources(plan.requirements),
      duration: plan.duration,
    })),
  }
}
